import { DateTime } from 'luxon';

const TOKEN_KEY = '@translated/marketo/token';
const TOKEN_EXP = '@translated/marketo/iat';

class Storage {
  private _token: string | null;
  constructor() {
    this._token = localStorage.getItem(TOKEN_KEY);
  }

  get token() {
    return localStorage.getItem(TOKEN_KEY);
  }

  set token(t: string | null) {
    this._token = t;
    if (t) {
      localStorage.setItem(TOKEN_KEY, t);
      localStorage.setItem(TOKEN_EXP, String(DateTime.now().plus({ hour: 8 }).toMillis()));
    } else {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(TOKEN_EXP);
    }
  }

  isTokenExpired() {
    const exp = localStorage.getItem(TOKEN_EXP);
    if (exp) {
      const millis = Number(exp);
      if (isNaN(millis)) return true;
      return millis < DateTime.now().toMillis();
    }

    return false;
  }
}

export default new Storage();
